export const useOtherChatParticipantInfo = (chat, user) => {
    if (!chat) return {}

    return user.userId === chat.senderId ? {
      userId: chat.recipientId,
      name: chat.recipientName,
      avatar: chat.recipientAvatar,
      lastReadMessageId: chat.recipientLastReadMessageId
    } : {
      userId: chat.senderId,
      name: chat.senderName,
      avatar: chat.senderAvatar,
      lastReadMessageId: chat.senderLastReadMessageId
    }

}


// WEBPACK FOOTER //
// ./src/containers/ChatsPage/hooks/useOtherChatParticipantInfo.ts